[
    {  
      "id":1,
      "image": "cat",
      "name": "Convective Alerting Tool (CAT)",
      "description": "Provide a rolling 1-hr and 3-hr rainfall view to assess convective risks and guide mitigation actions.",
      "route":"cat",
      "disabled": false
    },
    {
      "id":2,
      "image": "fsr",
      "name": "Fire & Steam Risk",
      "description": "Provide a view of fire risks, including those from steam trains, to help users plan activities and mitigation actions effectively.​",
      "route":"fsr",
      "disabled": false
    },
    {
      "id":3,
      "image": "profile",
      "name": "Profile",
      "description": "Allow users to personalize the system by setting default Region and Route preferences and managing alert and notification subscriptions.​",
      "route":"myProfile",
      "disabled": false
    },
    {
      "id":4,
      "image": "configuration",
      "name": "Configuration",
      "description": "Allows setup & maintenance of National Thresholds, toggling Features based on seasonal needs, or technical issues, configuring email templates and select application URLs.​",
      "route":"admin",
      "disabled": false
    },
    {
      "id":5,
      "image": "question_circle",
      "name": "Contact & Help",
      "description": "Provide users with essential materials to aid in using the ROWS system effectively.",
      "disabled": true
    }
  ]
  